import ar from './learner-dashboard/ar.json';
import de from './learner-dashboard/de.json';
import es from './learner-dashboard/es.json';
import it from './learner-dashboard/it.json';
import lb from './learner-dashboard/lb.json';
import pt from './learner-dashboard/pt.json';
import ru from './learner-dashboard/ru.json';
import uk from './learner-dashboard/uk.json';
import tr from './learner-dashboard/tr.json';

/** Espace apprenant : surcharge complète pour langues qui n’avaient que `learner.sidebar.tagline` dans i18n.ts. */
export const learnerDashboardLocales: Partial<Record<string, Record<string, string>>> = {
  ar,
  de,
  es,
  it,
  pt,
  lb,
  uk,
  ru,
  tr,
};
